/**
 * Represents a user
 */
export class User {

    constructor(){
        this.userName = '';
        this.userId = '';
        this.account = '';
        this.firstName = '';
        this.lastName = '';
        this.companyId = '';
        this.companyName = '';
        this.isActive = false;
        this.emailAddress = '';
        this.homeBranchId = ''
    }


}